module.exports = __webpack_public_path__ + "@/assets/img/bell.eef2202d.png";